<template>
  <div :class="$style.diKemasKiniContainer">
    <span :class="$style.textContainer">
      <span :class="$style.diKemasKini">Dikemaskini pada</span>
      <span :class="$style.span">:</span>
      <span :class="$style.dateText"> {{ formattedDate }}</span>
    </span>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'

const options = ref({ day: 'numeric', month: 'long', year: 'numeric' })

const formattedDate = computed(() => {


  return new Date().toLocaleDateString('ms-MY', options)

})
</script>


<style module>
.diKemasKiniContainer {
  color: #000;
  font-family: Inter;
  font-size: 20px;
  inline-size: 100%; /* Take up full width */
  padding-inline-end: 20px; /* Add padding to avoid sticking to the edge */
  text-align: end; /* Ensure text is aligned right */
}

.textContainer {
  display: inline-block; /* Ensures text spans stay inline */
}

.diKemasKini {
  font-weight: 500;
}

.span {
  font-family: Inter;
  font-weight: 600;
}

.dateText {
  color: #2900cf;
  font-weight: 500;
  margin-inline-start: 5px;
}
</style>
